export const TYPES = [
  { label: 'Ny kund', key: 'new_client' },
  { label: 'Uppdatering', key: 'update' },
  { label: 'Tillägg', key: 'addon' }
]

export const INVOICE_ACTION = [
  { label: 'Ingen ändring (samma som tidigare inskickat)', key: 'no_update' },
  { label: 'Samma som objektsadress', key: 'postal_address' },
  { label: 'Ny fakturaaadress', key: 'new' }
]

export const PERMISSION_CODES_FORM = [
  { label: 'Ej relevant', key: 'permission_no_relevance' },
  { label: 'Gemensam behörighetskod', key: 'permission_mutual' },
  { label: 'Personliga behörighetskoder', key: 'permission_personal_codes' },
  { label: 'Samma som tidigare inskickat (ingen ändring)', key: 'permission_contact_no_update' }
]

export const PERMISSIONS_CONTACT_LEVELS = [
  { label: 'B = Får meddela tillfälliga instruktioner', key: 'B' },
  { label: 'C = Får endast återkalla larm', key: 'C' }
]

export const PERMISSIONS_LEVELS_CONTACTS = [
  { label: 'A = Full behörighet', key: 'A' },
  { label: 'B = Får meddela tillfälliga instruktioner', key: 'B' },
  { label: 'C = Får endast återkalla larm', key: 'C' },
  { label: 'X = Ej behörig', key: 'X' }
]

export const PERMISSION_WEB = [
  { label: 'Nej - Önskas inte', key: 'false' },
  { label: 'Ja - Skall kunna administrera', key: 'true' }
]

export const KEYS_OPTIONS = [
  { label: 'Ej relevant', key: 'keys_no_relevance' },
  { label: 'Samma som tidigare (ingen ändring)', key: 'keys_no_update' },
  { label: 'Lämnas av kund', key: 'client_drop' },
  { label: 'Lämnas av installatör', key: 'installation_drop' },
  { label: 'Skickas rekommenderat', key: 'post_drop' },
  { label: 'Hämtas av vaktbolag (avgift kan förekomma)', key: 'security_drop' },
]

export const ALARM_INSTRUCTIONS = [
  {
    label: 'Åtgärdstyp A',
    text: `1. Ring kontaktperson
    2. Ej svar: Ingen åtgärd`,
    key: 'A'
  },
  {
    label: 'Åtgärdstyp B',
    text: `1. Ring kontaktperson
    2. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'B'
  },
  {
    label: 'Åtgärdstyp C',
    text: `1. Väktare för kontroll
    2. Meddela polis vid inbrott/skada
    3. Meddela kontaktperson vid inbrott/skada`,
    key: 'C'
  },
  {
    label: 'Åtgärdstyp D',
    text: `1. Ring objekt.
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Ingen åtgärd`,
    key: 'D'
  },
  {
    label: 'Åtgärdstyp E',
    text: `1. Ring objekt
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'E'
  },
  {
    label: 'Egen instruktion',
    text: 'Enligt beskrivning nedan',
    key: 'custom'
  }
]

export const SABOTAGE_INSTRUCTIONS = [
  {
    label: 'Åtgärdstyp A',
    text: `1. Ring kontaktperson
    2. Ej svar: Ingen åtgärd`,
    key: 'A'
  },
  {
    label: 'Åtgärdstyp B',
    text: `1. Ring kontaktperson
    2. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'B'
  },
  {
    label: 'Åtgärdstyp C',
    text: `1. Väktare för kontroll
    2. Meddela polis vid inbrott/skada
    3. Meddela kontaktperson vid inbrott/skada`,
    key: 'C'
  },
  {
    label: 'Åtgärdstyp D',
    text: `1. Ring objekt.
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Ingen åtgärd`,
    key: 'D'
  },
  {
    label: 'Åtgärdstyp E',
    text: `1. Ring objekt
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'E'
  },
  {
    label: 'Egen instruktion',
    text: 'Enligt beskrivning nedan',
    key: 'custom'
  }
]


export const EMERGENCY_INSTRUCTIONS = [
  {
    label: 'Åtgärdstyp A',
    text: `1. Ring kontaktperson
    2. Ej svar: Ingen åtgärd`,
    key: 'A'
  },
  {
    label: 'Åtgärdstyp B',
    text: `1. Ring kontaktperson
    2. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'B'
  },
  {
    label: 'Åtgärdstyp C',
    text: `1. Väktare för kontroll
    2. Meddela polis vid inbrott/skada
    3. Meddela kontaktperson vid inbrott/skada`,
    key: 'C'
  },
  {
    label: 'Åtgärdstyp D',
    text: `1. Ring objekt.
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Ingen åtgärd`,
    key: 'D'
  },
  {
    label: 'Åtgärdstyp E',
    text: `1. Ring objekt
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'E'
  },
  {
    label: 'Ej aktuellt',
    text: 'Nödlarm hanteras ej',
    key: 'not_handled'
  },
  {
    label: 'Egen instruktion',
    text: 'Enligt beskrivning nedan',
    key: 'custom'
  }
]

export const FALSE_ALARM_INSTRUCTIONS = [
  {
    label: 'Åtgärdstyp A',
    text: `1. Ring kontaktperson
    2. Ej svar: Ingen åtgärd`,
    key: 'A'
  },
  {
    label: 'Åtgärdstyp B',
    text: `1. Ring kontaktperson
    2. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'B'
  },
  {
    label: 'Åtgärdstyp C',
    text: `1. Väktare för kontroll
    2. Meddela polis vid inbrott/skada
    3. Meddela kontaktperson vid inbrott/skada`,
    key: 'C'
  },
  {
    label: 'Åtgärdstyp D',
    text: `1. Ring objekt.
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Ingen åtgärd`,
    key: 'D'
  },
  {
    label: 'Åtgärdstyp E',
    text: `1. Ring objekt
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'E'
  },
  {
    label: 'Egen instruktion',
    text: 'Enligt beskrivning nedan',
    key: 'custom'
  }
]

export const FIRE_INSTRUCTIONS = [
  {
    label: 'Åtgärdstyp A',
    text: `1. Ring objekt.
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Ingen åtgärd`,
    key: 'A'
  },
  {
    label: 'Åtgärdstyp B',
    text: `1. Ring objekt
    2. Ej svar: Ring kontaktperson
    3. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'B'
  },
  {
    label: 'Åtgärdstyp C',
    text: `1. Väktare för kontroll
    2. Meddela polis vid inbrott/skada
    3. Meddela kontaktperson vid inbrott/skada`,
    key: 'C'
  },
  {
    label: 'Åtgärdstyp D',
    text: `1. Ring kontaktperson
    2. Ej svar: Ingen åtgärd`,
    key: 'D'
  },
  {
    label: 'Åtgärdstyp E',
    text: `1. Ring kontaktperson
    2. Ej svar: Väktare för kontroll
    4. Meddela polis vid inbrott/skada
    5. Meddela kontaktperson vid inbrott/skada`,
    key: 'E'
  },
  {
    label: 'Ej aktuellt',
    text: 'Brandlarm hanteras ej',
    key: 'not_handled'
  },
  {
    label: 'Egen instruktion',
    text: 'Enligt beskrivning nedan',
    key: 'custom'
  }
]